import React, { useCallback } from 'react'

import type { ContactFieldConfig } from './EditContactsModal.types'
import { isPhoneFieldType } from './editContactsValidation'

export type ContactSide = 'primary' | 'secondary'

type ContactFieldProps = {
    field: ContactFieldConfig
    side: ContactSide
    value: string
    errorMessage?: string
    disabled: boolean
    onChange: (side: ContactSide, key: string, value: string) => void
}


const sanitizePhoneValue = (rawValue: string): string => rawValue.replace(/[^\d+]/g, '')

export const ContactField: React.FC<Readonly<ContactFieldProps>> = ({
    field,
    side,
    value,
    errorMessage,
    disabled,
    onChange,
}) => {
    const inputId = `${side}-${field.fieldKey}`
    const inputType = isPhoneFieldType(field.fieldType) ? 'tel' : field.fieldType
    const inputClassName = errorMessage
        ? 'edit-contacts-modal__input edit-contacts-modal__input--error'
        : 'edit-contacts-modal__input'

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>): void => {
            const rawValue = e.target.value
            const nextValue = isPhoneFieldType(field.fieldType)
                ? sanitizePhoneValue(rawValue)
                : rawValue
            onChange(side, field.fieldKey, nextValue)
        },
        [onChange, side, field.fieldKey],
    )

    return (
        <div className="edit-contacts-modal__field">
            <label className="edit-contacts-modal__label" htmlFor={inputId}>
                {field.fieldLabel}
            </label>
            <input
                id={inputId}
                type={inputType}
                className={inputClassName}
                value={value}
                placeholder={field.placeholder}
                onChange={handleInputChange}
                disabled={disabled}
                autoComplete="off"
            />
            {errorMessage && (
                <span className="edit-contacts-modal__error">{errorMessage}</span>
            )}
        </div>
    )
}
